import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={51}
    height={51}
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={51} height={51} rx={25.5} fill="#233877" />
    <g clipPath="url(#clip0_4416_463)">
      <path
        d="M27.4042 9.11938C22.1321 9.11938 17.4659 11.7513 14.6415 15.7677C15.226 16.149 15.7958 16.6719 16.3469 17.3442C18.454 14.1936 21.8609 11.9831 25.8028 11.5079L27.404 14.2174L29.0051 11.5078C35.0644 12.2381 39.8808 17.0543 40.6114 23.1136L37.9015 24.7149L40.6115 26.3163C40.1231 30.3674 37.803 33.8551 34.5116 35.9455C34.7213 36.4234 34.8393 36.9121 34.8602 37.4159C34.8756 37.7841 34.8376 38.132 34.7613 38.4622C39.6607 35.8297 43 30.6558 43 24.7152C43 16.1154 36.004 9.11938 27.4042 9.11938ZM31.3841 34.8042C27.7888 31.9148 26.7835 33.3351 25.1522 34.9661C24.0134 36.1054 21.1314 33.7264 18.6429 31.2378C16.1542 28.7488 13.7756 25.8673 14.9144 24.7282C16.5458 23.0971 17.9657 22.0912 15.0755 18.497C12.1863 14.9014 10.2603 17.6618 8.68005 19.2422C6.8557 21.0659 8.58391 27.8621 15.3008 34.5801C22.0187 41.2971 28.8148 43.0241 30.6381 41.2011C32.2181 39.6207 34.9793 37.6949 31.3841 34.8042ZM20.4345 27.1559C20.4345 23.9601 24.1758 23.3908 24.1758 22.1437C24.1758 21.5386 23.6914 21.2846 23.2434 21.2846C22.4201 21.2846 21.9604 22.2044 21.9604 22.2044L20.3865 21.1512C20.3865 21.1512 21.1856 19.2868 23.4374 19.2868C24.8537 19.2868 26.3912 20.0981 26.3912 21.9381C26.3912 24.6379 22.9045 25.1587 22.8438 26.2725H26.5246V28.0883H20.5316C20.4709 27.7494 20.4345 27.4469 20.4345 27.1559ZM27.4096 24.7107L30.7514 19.4319H33.3422V24.2385H34.3711V25.9937H33.3422V28.0884H31.2474V25.9937H27.4097V24.7107H27.4096ZM31.2474 24.2384V22.3013C31.2474 21.8291 31.3201 21.3326 31.3201 21.3326H31.2959C31.2959 21.3326 31.1145 21.8654 30.8721 22.2287L29.5649 24.2143V24.2385L31.2474 24.2384Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4416_463">
        <rect width={35} height={35} fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
